
const FatigaEntrenamiento = ({axios, env})=>({

    Stats : async ( body ) => {
        try {
            const { data } = await axios.post( `${env.api_uri}/test/profile-stats`, body )
            return data
        } catch (error) {
            console.log(error)
        }
    },
    Individual : async ( body ) => {
        try {
            const { data } = await axios.post( `${env.api_uri}/test/profile-stats-mac`, body )
            return data
        } catch (error) {
            console.log(error)
        }
    },
    Dates : async (_id)=>{
        try {
            const { data } = await axios.get(`${env.api_uri}/test/profile-dates/${_id}`)
            return data
        }catch(error){
            console.log(error)
        }
    }
    

})


export default FatigaEntrenamiento